export default function WhoIsFor() {
  const targetAudience = [
    {
      icon: 'ri-building-2-line',
      title: '剛成立的公司/品牌',
      description: '需要快速建立品牌形象'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '不想一次投入高額建站費',
      description: '希望先小額測試市場反應'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '希望有人長期幫忙處理網站',
      description: '專注本業，網站交給專業'
    },
    {
      icon: 'ri-arrow-up-line',
      title: '未來可能升級表單、LINE、金流、系統',
      description: '需要擴充彈性與成長空間'
    }
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            適合誰？
          </h2>
          <div className="w-20 h-1 bg-teal-500 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {targetAudience.map((item, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100"
            >
              <div className="flex items-start">
                <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-2xl text-teal-600`}></i>
                </div>
                <div className="ml-5">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-white rounded-2xl p-8 md:p-10 shadow-sm border-2 border-teal-100 text-center">
          <i className="ri-user-heart-line text-5xl text-teal-500 mb-4"></i>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            如果您是以上任一種情況
          </h3>
          <p className="text-lg text-gray-700">
            0元一頁式網站就是為您設計的起步方案
          </p>
        </div>
      </div>
    </section>
  );
}
